import { AxiosRequestConfig } from "axios";

import {
	ITEComunicacionInput,
	ITEComunicacionOutput,
	ITEComunicacionUpdateInput,
} from "components/ITE/types/comunicaciones";

import { apiClient, CustomAxiosRequest } from ".";

type getComunicacionesPropsType = {
	iteId: string;
};

export const getComunicaciones: CustomAxiosRequest<getComunicacionesPropsType, ITEComunicacionOutput[]> = (props) => {
	const url = `ite/ite/comunicaciones`;
	const config: AxiosRequestConfig = {
		method: "GET",
		url,
		headers: {
			"Content-Type": "application/json",
		},
		params: props,
	};
	return apiClient(config);
};

export const postComunicacion: CustomAxiosRequest<ITEComunicacionInput, ITEComunicacionOutput> = (data) => {
	const url = `ite/ite/comunicaciones`;
	const config: AxiosRequestConfig = {
		method: "POST",
		url,
		headers: {
			"Content-Type": "application/json",
		},
		data: data,
	};
	return apiClient(config);
};

type putComunicacionPropsType = {
	id: string;
	data: ITEComunicacionUpdateInput;
};

export const putComunicacion: CustomAxiosRequest<putComunicacionPropsType, ITEComunicacionOutput> = (data) => {
	const url = `ite/ite/comunicaciones/${data.id}`;
	const config: AxiosRequestConfig = {
		method: "PUT",
		url,
		headers: {
			"Content-Type": "application/json",
		},
		data: data.data,
	};
	return apiClient(config);
};
